/**
 * @file UserMessagePreview.js
 * @description Component for displaying the selected message preview with formatted content
 */

import styles from './UserMessageList.module.scss';
import RichTextContent from '../../ui/RichTextContent';
import { getText } from '../../../i18n';

const UserMessagePreview = ({ message, renderChannelIcon }) => {
    if (!message) return null;

    return (
        <>
            <hr />
            <div className={styles.messagePreview}>
                <div className={styles.previewHeader}>
                    <div className={styles.previewHeaderContent}>
                        <div className="container">

                            <h6 className='pb-4'>{message.subject || '[No Subject]'}</h6>

                            {message.messages.map((msg, index) => (
                                <div className='row {styles.sentToContainer}'>
                                    <div className="col-1">
                                        {index === 0 ? <b>{getText('msg_c8a76cfeccfd')}</b> : ""}
                                    </div>
                                    <div className="col-8">
                                        <span
                                            className={`${styles.channelIcon} text-success`}
                                        >
                                            {renderChannelIcon(
                                                msg.notificationMessageChannelId,
                                            )}
                                        </span>{' '}
                                        {msg.notificationMessageChannelId !== 3 ? msg.destination || '' : 'Push Notification'}
                                    </div>
                                    <div className="col-2">
                                        <span key="date" className={styles.metadataItem}>
                                            {msg.sentDateFormatted}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
                <div className="container">
                    <RichTextContent content={message.htmlBody || ''} />
                </div>
            </div>
        </>
    );
};

export default UserMessagePreview;
